/**
 * Accès aux indicateurs.
 *
 * `docs/DECISIONS.md` D29 : deux niveaux de lecture. Le tableau de bord combine les deux — jour et
 * tendance — en un seul appel ; les écrans par catégorie n'en ont besoin que d'un.
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "../../shared/api/client";
import type { Indicateur, TableauDeBord } from "../../shared/api/types";

export function useTableauDeBord() {
  return useQuery({
    queryKey: ["kpi", "tableau-de-bord"],
    queryFn: () => api.lire<TableauDeBord>("/v1/kpi/tableau-de-bord"),
    // Les indicateurs de tendance viennent d'un instantané quotidien : inutile de solliciter le
    // serveur plus souvent que ça ne peut changer.
    staleTime: 5 * 60_000,
  });
}

export function useIndicateurs(categorie: string) {
  return useQuery({
    queryKey: ["kpi", "categorie", categorie],
    queryFn: () => api.lire<Indicateur[]>(`/v1/kpi/${encodeURIComponent(categorie)}`),
    staleTime: 5 * 60_000,
  });
}
